<template>
  <v-dialog
    fullscreen
    eager
    v-model="dialog"
    hide-overlay
    content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-card-text>
        <v-container>
          <v-row justify="center">
            <v-col cols="5">
              <v-skeleton-loader
                v-show="!isLoaded"
                max-width="711"
                max-height="536"
                width="711"
                height="536"
                type="image"
              ></v-skeleton-loader>
              <v-img :src="imgSrc" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import html2canvas from 'html2canvas';
import EditorService from '@/modules/display/services/editor-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: 'PreviewAds',
  data() {
    return {
      dialog: false,
      body: '',
      imgSrc: '',
      isLoaded: false
    }
  },
  methods: {
    initialization(body) {
      this.dialog = true;
      this.isLoaded = false;
      html2canvas(body, {
        letterRendering: 1,
        allowTaint: false,
        useCORS: true,
        width: 1280,
        height: 720
      }).then((canvas) => {
       this.loadPreview(canvas.toDataURL('image/png'));
      }).catch((error) => {
        this.$logger.error("Failed to create preview image during canvas image creation, because: ", error);
        this.dialog = false;
        Utils.showFailureSnackbar(this.$t('display/editor:error.canvas-preview-creation'))
      });
    },
    loadPreview(imageFromWysiwyg) {
      let image = imageFromWysiwyg.split('data:image/png;base64,');
      let blob = Utils.base64toBlob(image[1], 'image/png');
      EditorService.getPreview(blob,
          (response) => {
            this.imgSrc = response.data;
            this.isLoaded = true;
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('common:media_plural')}));
          }
      );
    },
    closeDialog() {
      this.dialog = false;
      this.isLoaded = false;
      this.imgSrc = '';
    }
  }
}
</script>


<style>
.v-skeleton-loader__image {
  height: 791px;
}
</style>
